/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var UrlIcon = createIcon("UrlIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return /*#__PURE__*/React.createElement("svg", {
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "M44 0H4a4 4 0 00-4 4v40a4 4 0 004 4h40a4 4 0 004-4V4a4 4 0 00-4-4Z",
    fill: "#C8C8C8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m18.022 23.02.35.012a1 1 0 11-.116 1.996 4.964 4.964 0 00-3.571 1.235l-.22.206-3 3a4.997 4.997 0 002.241 8.361 5 5 0 004.614-1.09l.216-.203 3-2.999a4.964 4.964 0 001.442-3.79 1 1 0 011.996-.115 6.958 6.958 0 01-1.784 5.065l-.24.254-3 2.998a7.002 7.002 0 01-11.711-3.136 6.996 6.996 0 011.587-6.524l.224-.235 3.001-3a6.964 6.964 0 014.971-2.034Zm13.685-6.723a1 1 0 01.097 1.301l-.097.112-14 13.995a1 1 0 01-1.51-1.302l.096-.112 14-13.994a1 1 0 011.414 0Zm3.105-8.058a6.999 6.999 0 013.363 11.471l-.225.235-3 3a6.966 6.966 0 01-5.32 2.023 1 1 0 11.114-1.996 4.965 4.965 0 003.572-1.235l.22-.206 3-3a4.997 4.997 0 00-2.242-8.361 5.002 5.002 0 00-4.614 1.09l-.215.203-2.999 2.997a4.964 4.964 0 00-1.437 3.791 1 1 0 01-1.996.117 6.963 6.963 0 011.777-5.066l.24-.253 3-3a7.002 7.002 0 016.762-1.81Z",
    fill: "#171717"
  }));
}, {
  "i18nKey": "svg.UrlIcon"
});